<script lang="ts" setup>
import { useRecordingError } from './logic'

const error = useRecordingError()
</script>

<template v-once>
  <AlertDialog
    v-if="error.cause.notFound || error.cause.invalid"
    class="m-auto"
    icon="tdesign:search-error"
    title="The file you are looking for does not exist"
    subtitle="Please contact us if you think this is an error."
  />

  <AlertDialog
    v-else-if="error.cause.parsing"
    class="m-auto"
    icon="solar:bill-list-broken"
    title="An error occurred while parsing the file"
    subtitle="We have been notified, and will promptly fix the issue."
  />

  <AlertDialog
    v-else
    class="m-auto"
    icon="solar:bill-list-broken"
    title="We could not load the file"
    subtitle="We have been notified, and will promptly fix the issue."
  />
</template>
